import { AnimatePresence, motion } from "motion/react";
import { ComponentProps } from "react";
import cx from "classnames";

export const ClosingShade = ({
  isOpen,
  onClose,
  className,
  ...props
}: {
  isOpen: boolean;
  onClose: () => void;
} & ComponentProps<typeof motion.button>) => (
  <AnimatePresence>
    {isOpen && (
      <motion.button
        aria-hidden
        tabIndex={-1}
        onClick={onClose}
        data-lenis-prevent
        className={cx(
          "bg-neutral-dark/60 fixed top-0 bottom-0 left-0 right-0 -z-20 cursor-auto",
          className
        )}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
        {...props}
      />
    )}
  </AnimatePresence>
);
